import React, { useEffect } from "react";
import { useStore } from "zustand";

import { insightDetailComponentStore } from "../../store/insightDetailComponent";
import type {
    InsightDetailOption,
    InsightDetailSelectionProps,
} from "../../utils/insightDetail.utils";

export interface InsightDetailComponentsProp {
    identifier: string;
    familyName: string;
    InsightHeaderOption: InsightDetailOption;
    InsightBodyOption: InsightDetailOption;
    InsightFooterOption: InsightDetailOption;
    headerReady: boolean;
    bodyReady: boolean;
    footerReady: boolean;
    handleMount: (props: InsightDetailSelectionProps) => void;
    handleClose: () => void;
}

export const useSetInsightDetailComponents = (
    props: InsightDetailComponentsProp,
): (() => void) => {
    const {
        identifier,
        familyName,
        InsightHeaderOption,
        InsightBodyOption,
        InsightFooterOption,
        headerReady,
        bodyReady,
        footerReady,
        handleMount,
        handleClose,
    } = props;

    const [
        setOpen,
        setOnMount,
        setOnClose,
        setHeaderOption,
        setBodyOption,
        setFooterOption,
        setIdentifier,
        setFamilyName,
    ] = useStore(insightDetailComponentStore, (state) => [
        state.setOpen,
        state.setOnMount,
        state.setOnClose,
        state.setHeaderOption,
        state.setBodyOption,
        state.setFooterOption,
        state.setIdentifier,
        state.setFamilyName,
    ]);

    React.useEffect(() => {
        if (headerReady) {
            setHeaderOption(InsightHeaderOption);
        }
    }, [headerReady, InsightHeaderOption]);

    React.useEffect(() => {
        if (bodyReady) {
            setBodyOption(InsightBodyOption);
        }
    }, [bodyReady, InsightBodyOption]);

    React.useEffect(() => {
        if (footerReady) {
            setFooterOption(InsightFooterOption);
        }
    }, [footerReady, InsightFooterOption]);

    useEffect(() => {
        if (identifier) {
            setIdentifier(identifier);
        }
    }, [identifier]);

    useEffect(() => {
        if (familyName) {
            setFamilyName(familyName);
        }
    }, [familyName]);

    const handleClick = () => {
        setOpen(true);
        setOnClose(handleClose);
        setOnMount(handleMount);
    };

    return handleClick;
};
